export const MAX_FILE_SIZE_TO_IMPORT_UPCS = 2 * 1024 * 1024;
